import { render } from "./ExtensionCard.vue?vue&type=template&id=00720c85&scoped=true&ts=true"
import script from "./ExtensionCard.vue?vue&type=script&lang=ts"
export * from "./ExtensionCard.vue?vue&type=script&lang=ts"

import "./ExtensionCard.vue?vue&type=style&index=0&id=00720c85&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00720c85"]])

export default __exports__